import React, { useEffect, useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Loader from '../../components/UI/Loader';
import AppComponent from './component';
import { AnalyticsContext } from '../../ModularReduxAnalytics';
import useFeatureToggles from './hooks/useFeatureToggles';
import useDatadogRUM from './hooks/useDatadogRUM';
import useRedirect from './hooks/useRedirect';
import useProveMobileAuth from './hooks/useProveMobileAuth';
import useSessionData from './hooks/useSessionData';
import css from './App.module.scss';
import { storageAvailable } from '../../helpers';

import { useUserDispatchers } from '../../state/user';

export const getAnonymousId = async (segment, attempts = 0) => {
  // First attempt getting it from several providers
  let anonymousId = segment.getAnonymousId();
  if (anonymousId) {
    return anonymousId;
  }

  // Try up to 3 seconds
  if (attempts < 10) {
    const newAttempts = attempts + 1;

    // First attempt several providers again
    anonymousId = segment.getAnonymousId();
    if (anonymousId) {
      return anonymousId;
    }
    // Next try straight out of segment
    if (window.analytics && typeof window.analytics.user === `function`) {
      return window.analytics.user().anonymousId();
    }

    await new Promise(resolve => setTimeout(resolve, 300));

    return getAnonymousId(segment, newAttempts);
  }

  // Let's not fail outright I suppose.
  return uuidv4();
};

const App = props => {
  const featuresLoading = useFeatureToggles();
  const { segment } = useContext(AnalyticsContext);
  useDatadogRUM();
  useRedirect();
  useSessionData();
  useProveMobileAuth();
  const { setDeviceUUID } = useUserDispatchers();

  useEffect(() => {
    const uuid = uuidv4();

    if (storageAvailable('localStorage')) {
      localStorage.setItem('device-uuid', uuid);
    }

    setDeviceUUID(uuid);
    segment.setDeviceUuid(uuid);
  }, []);

  return (
    <div className={`${css.App} fs-unmask`}>
      {featuresLoading ? <Loader /> : <AppComponent {...props} />}
    </div>
  );
};

export default React.memo(App);
